import IndexContent from "../../indexSignal/index_signal";
import CognitoController from "@/common/scripts/cognito_controller";

const setNewInfo = (self: IndexContent, signallampIDs: number[]) => {
  self.signallampIDs = signallampIDs;
};

const makeIds = (self: IndexContent): number[] => {
  if (
    typeof self.signallampIDs === "undefined" ||
    self.signallampIDs.length === 0
  ) {
    return [1];
  } else {
    const ids: number[] = Object.assign([], self.signallampIDs);
    ids.push(Math.max.apply(null, ids) + 1);
    return ids;
  }
};

export async function AddSignallamp(self: IndexContent) {
  const signallampIDs: number[] = makeIds(self);
  const cognitoController = new CognitoController();
  cognitoController.setSignallampIDs(signallampIDs);
  const result = await cognitoController.update();
  setNewInfo(self, signallampIDs);
  return result;
}
